import React from 'react'
import { prop, isEmpty, isNil } from 'ramda'
import { isFalse } from 'utils/types'

/**
 * wraps parts of strings in spans and outputs a component
 * @param { String } string
 * @param { Object } conditions
 * @example
 *    wrapAndReplace('This is a test', { test: 'replacement' })
 *    // => <>This is a <span>replacement</span>
 *
 *    wrapAndReplace('This is a test', { test: null })
 *    // => <>This is a test</>
 *
 */
const wrapAndReplace = (string, conditions) => {
  if (isEmpty(conditions)) return string

  const matchKeysRegex = new RegExp(`(${Object.keys(conditions).join('|')})`)
  const stringSplit = string.split(matchKeysRegex)

  const mapper = (s, index) => {
    const found = prop(s, conditions)

    return !isNil(found) && !isFalse(found) ? (
      <span key={`${s}-${index}`}>{found}</span>
    ) : (
      s
    )
  }

  return <>{stringSplit.map(mapper)}</>
}

export default wrapAndReplace
